"use strict";
"use client";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var session_provider_exports = {};
__export(session_provider_exports, {
  SessionProvider: () => SessionProvider
});
module.exports = __toCommonJS(session_provider_exports);
var import_jsx_runtime = (
  // @ts-expect-error copying next auth for this one (value mismatch)
  require("react/jsx-runtime")
);
var import_web_utils = require("@checkatrade/web-utils");
var import_react = require("react");
var import_context = require("../context");
var import_get_client = require("../session/get-client");
var import_refresh_token_and_profile = require("../session/refresh-token-and-profile");
var import_now = require("../utils/now");
let channel = null;
const CHANNEL = "checkatrade-auth";
function createNewChannel() {
  if (typeof BroadcastChannel === "undefined") {
    throw new Error("BroadcastChannel is not supported in this environment.");
  }
  return new BroadcastChannel(CHANNEL);
}
function broadcast() {
  if (!channel) {
    channel = createNewChannel();
  }
  return channel;
}
const _CHECKATRADE_AUTH = {
  lastSync: 0
};
const SessionProvider = (props) => {
  const [loading, setLoading] = (0, import_react.useState)(!props.session);
  const [session, setSession] = (0, import_react.useState)(() => {
    if (!props.session) return null;
    return props.session;
  });
  const getSession = (0, import_react.useCallback)(
    async (options = { broadcast: true }) => {
      const currentSession = await (0, import_get_client.getClientSession)();
      _CHECKATRADE_AUTH.lastSync = (0, import_now.now)();
      if (options.broadcast) {
        broadcast().postMessage({
          type: "session"
        });
      }
      setSession(currentSession);
      return currentSession;
    },
    []
  );
  (0, import_react.useEffect)(() => {
    const initialiseSession = async () => {
      await getSession();
      setLoading(false);
    };
    initialiseSession();
  }, [getSession]);
  const value = (0, import_react.useMemo)(
    () => ({
      data: session,
      status: loading ? "loading" : session ? "authenticated" : "unauthenticated",
      update: async () => {
        if (loading) {
          return session;
        }
        setLoading(true);
        await (0, import_refresh_token_and_profile.refreshTokenAndProfile)();
        const newSession = await getSession();
        setLoading(false);
        return newSession;
      }
    }),
    [loading, session, getSession]
  );
  const { children } = props;
  const intervalDelay = session ? 1e3 * 60 * 2 : null;
  (0, import_web_utils.useInterval)(() => session && getSession(), intervalDelay);
  (0, import_react.useEffect)(() => {
    const handle = () => {
      if (document.visibilityState === "visible") {
        getSession();
      }
    };
    document.addEventListener("visibilitychange", handle, false);
    return () => document.removeEventListener("visibilitychange", handle, false);
  }, []);
  (0, import_react.useEffect)(() => {
    const handle = () => {
      getSession({ broadcast: false });
    };
    broadcast().addEventListener("message", handle);
    return () => {
      broadcast().removeEventListener("message", handle);
    };
  }, [getSession]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_context.SessionContext.Provider, { value, children });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  SessionProvider
});
